import { render, staticRenderFns } from "./SelectHighlightsTable.vue?vue&type=template&id=61871970"
import script from "./SelectHighlightsTable.vue?vue&type=script&lang=js"
export * from "./SelectHighlightsTable.vue?vue&type=script&lang=js"
import style0 from "./SelectHighlightsTable.vue?vue&type=style&index=0&id=61871970&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports